export default __webpack_public_path__ + "static/media/logo-large.12ab1251.png";